module.exports = __webpack_public_path__ + "../resources/img/guideStep5.31410093.png";